export const selectFaceMatchStartDate = (state) =>
  state.calendar["face-matching"]
    ? state.calendar["face-matching"].startDate
    : state.calendar.face_match_default.startDate;

export const selectFaceMatchEndDate = (state) =>
  state.calendar["face-matching"]
    ? state.calendar["face-matching"].endDate
    : state.calendar.face_match_default.endDate;
